module.exports = "<div ng-style=\"{'background-image': 'url(' + vm.iconsSrc + ')'}\" />"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/weatherIcons/weatherIcons.html
 ** module id = 183
 ** module chunks = 0
 **/